import { marked } from 'marked';

// %[](https://example.com/image.jpg){rounded-corners}
const rule = new RegExp([
  '\\%',
  '\\[',
    '(?<alt>.*?)',
  '\\]',
  '\\(',
    '(?<src>.*?)',
  '\\)',
  '\\{',
    '(?<extra>.*?)',
  '\\}',
 ].join(''));

const extension = {
  name: "regolith-image",
  level: "inline",
  start(src: string) { return src.match(rule)?.index; },
  tokenizer(src: string) {
    const match = rule.exec(src);
    if (match) {
      const [raw, alt, src, classes] = match;
      const token = {
        type: 'regolith-image',
        raw: raw.trim(),
        alt: alt.trim(),
        src: src.trim(),
        classes: classes.trim(),
      };
      return token;
    }
  },
  renderer({src, alt, classes}) {
    return `
      <img
        src='${src}'
        alt='${alt}'
        class='${classes}'
      />
    `
  }
};

function walkTokens(token) { // Post-processing on the completed token tree
  if (token.type === 'strong') {
    token.text += ' walked';
    token.tokens = this.Lexer.lexInline(token.text)
  }
}

marked.use({ extensions: [extension], walkTokens });
